import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'button[khA11yActionButton]'
})
export class A11yActionButtonDirective {
  @HostBinding('attr.type') public readonly type = 'button';
}
